import React from "react";

const WhatsApp: React.FC = () => {
  return (
    <div className="text-neutral-500">
      <a href="https://wa.me/917386796083">
        <img src="/images/whatsapp.png" alt="whatsapp" className="w-56 h-12" />
      </a>
    </div>
  );
};

export default WhatsApp;
